/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timeline_Adjust_End_Time_Aria_LabelInputs */

const en_timeline_adjust_end_time_aria_label = /** @type {(inputs: Timeline_Adjust_End_Time_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adjust end time`)
};

const fr_timeline_adjust_end_time_aria_label = /** @type {(inputs: Timeline_Adjust_End_Time_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajuster l'heure de fin`)
};

const de_timeline_adjust_end_time_aria_label = /** @type {(inputs: Timeline_Adjust_End_Time_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Endzeit anpassen`)
};

const it_timeline_adjust_end_time_aria_label = /** @type {(inputs: Timeline_Adjust_End_Time_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regola l'ora di fine`)
};

const ru_timeline_adjust_end_time_aria_label = /** @type {(inputs: Timeline_Adjust_End_Time_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Скорректировать время окончания`)
};

const es_timeline_adjust_end_time_aria_label = /** @type {(inputs: Timeline_Adjust_End_Time_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajustar la hora de finalización`)
};

const zh_cn2_timeline_adjust_end_time_aria_label = /** @type {(inputs: Timeline_Adjust_End_Time_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`调整结束时间`)
};

const ja_timeline_adjust_end_time_aria_label = /** @type {(inputs: Timeline_Adjust_End_Time_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`終了時間を調整する`)
};

const hi_timeline_adjust_end_time_aria_label = /** @type {(inputs: Timeline_Adjust_End_Time_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`समाप्ति समय समायोजित करें`)
};

const pt_pt2_timeline_adjust_end_time_aria_label = /** @type {(inputs: Timeline_Adjust_End_Time_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajustar horário de término`)
};

/**
* | output |
* | --- |
* | "Adjust end time" |
*
* @param {Timeline_Adjust_End_Time_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const timeline_adjust_end_time_aria_label = /** @type {((inputs?: Timeline_Adjust_End_Time_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeline_Adjust_End_Time_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_timeline_adjust_end_time_aria_label(inputs)
	if (locale === "de") return de_timeline_adjust_end_time_aria_label(inputs)
	if (locale === "it") return it_timeline_adjust_end_time_aria_label(inputs)
	if (locale === "ru") return ru_timeline_adjust_end_time_aria_label(inputs)
	if (locale === "es") return es_timeline_adjust_end_time_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_timeline_adjust_end_time_aria_label(inputs)
	if (locale === "ja") return ja_timeline_adjust_end_time_aria_label(inputs)
	if (locale === "hi") return hi_timeline_adjust_end_time_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_timeline_adjust_end_time_aria_label(inputs)
	return en_timeline_adjust_end_time_aria_label(inputs)
});